import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagenotfoundComponent } from './component/pagenotfound/pagenotfound.component';
import { ErrorpageComponent } from './component/errorpage/errorpage.component';

const routes: Routes = [
  {
    path:'admin',
    loadChildren:()=>import('./modules/admin/admin.module').then(m=>m.AdminModule)
  },
  {
    path:'',
    loadChildren:()=>import('./modules/mainsite/mainsite.module').then(x=>x.MainsiteModule)
  },
  {
    path:'page',
    component:PagenotfoundComponent,
    data:{breadcrumb:'settings'}
  },
  {
    path:'error',
    component:ErrorpageComponent,
    data:{breadcrumb:'settings'}
  },
  { path: '**', redirectTo: '', pathMatch: 'full' } 
];

@NgModule({
  imports: [RouterModule.forRoot(routes,  { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
